export default __webpack_public_path__ + "static/media/aek.87bb88fe.pdf";